import JwtService from '../../services/JWTService/JWTService';
import axios from 'axios';

const baseURL = `${process.env.REACT_APP_HAMMURABI_API}`;

let authTokens = localStorage.getItem('HammurabiAuth') ? JSON.parse(localStorage.getItem('HammurabiAuth')) : null;

const axiosInstance = axios.create({
	baseURL,
	headers: { Authorization: `Bearer ${authTokens?.fresh}` },
});

axiosInstance.interceptors.request.use(async req => {
	if (!authTokens) {
		authTokens = localStorage.getItem('HammurabiAuth') ? JSON.parse(localStorage.getItem('HammurabiAuth')) : null;
		axiosInstance.defaults.headers.Authorization = `Bearer ${authTokens?.fresh}`;
		req.headers.Authorization = `Bearer ${authTokens?.fresh}`;
	}

	const isValid = JwtService.isAuthTokenValid(authTokens?.fresh);

	if (isValid) return req;

	try {
		const response = await axios.post(
			`${baseURL}/auth/refresh`,
			{},
			{
				headers: {
					Authorization: `Bearer ${authTokens?.refresh}`,
				},
			}
		);

		if (!response || response.code === 401) {
			window.location.href = '/logout';
		}

		localStorage.setItem(
			'HammurabiAuth',
			JSON.stringify({ fresh: response.data.token, refresh: response.data.refresh })
		);
		axiosInstance.defaults.headers.Authorization = `Bearer ${response.data.token}`;
		req.headers.Authorization = `Bearer ${response.data.token}`;

		return req;
	} catch (error) {
		window.location.href = '/logout';
		return error;
	}
});

export default axiosInstance;
